import React, { useEffect, useState } from 'react';
import { Modal, Button, Form, Spinner } from 'react-bootstrap';
import { Formik } from 'formik';
import * as Yup from 'yup';
import Select from 'react-select';
import { toast } from 'react-toastify';
import { customStyles, DropdownIndicator } from '~/Styles/reactSelectStyles';
import { alterarOpcaoPagamento, lookupOpcoesIPTU } from '~/Services/GestaoIPTUService';
import { extrairMensagemErro } from '~/Utils/Helpers';

const schema = Yup.object({
  novoValor: Yup.number().required('Selecione a nova opção').nullable(),
  motivo: Yup.string().required('Informe o motivo').min(3, 'Motivo muito curto'),
});

const ModalAlterarOpcaoPagamento = ({ show, onHide, selecionados, onSucesso }) => {
  const [opcoes, setOpcoes] = useState([]);

  useEffect(() => {
    if (!show) return;
    let ativo = true;
    lookupOpcoesIPTU()
      .then((res) => {
        if (ativo) {
          // Replica UImovelCarne.pas:414-418 (Pgto.CommandText) — exclui 6/7 (Ordem Pagto).
          const filtradas = (res || []).filter((i) => i.codigo !== 6 && i.codigo !== 7);
          setOpcoes(filtradas.map((i) => ({ value: i.codigo, label: i.descricao })));
        }
      })
      .catch(() => {});
    return () => { ativo = false; };
  }, [show]);

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      await alterarOpcaoPagamento({
        codigos: selecionados,
        novo_valor: values.novoValor,
        motivo: values.motivo,
      });
      toast.success('Controle de Pagamento atualizado com sucesso.');
      onSucesso();
      onHide();
    } catch (err) {
      toast.error(extrairMensagemErro(err));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Alterar Opção de Pagamento</Modal.Title>
      </Modal.Header>
      <Formik
        initialValues={{ novoValor: null, motivo: '' }}
        validationSchema={schema}
        onSubmit={handleSubmit}
      >
        {({ values, errors, touched, setFieldValue, handleChange, handleBlur, handleSubmit: formSubmit, isSubmitting }) => (
          <Form onSubmit={formSubmit}>
            <Modal.Body>
              <p className="text-muted mb-3">
                {selecionados.length} imóvel(is) selecionado(s).
              </p>
              <Form.Group className="mb-3">
                <Form.Label>Nova Opção <span className="text-danger">*</span></Form.Label>
                <Select
                  options={opcoes}
                  value={opcoes.find((o) => o.value === values.novoValor) || null}
                  onChange={(opt) => setFieldValue('novoValor', opt ? opt.value : null)}
                  isClearable
                  placeholder="Selecione..."
                  styles={customStyles}
                  components={{ DropdownIndicator }}
                />
                {touched.novoValor && errors.novoValor && (
                  <div className="text-danger" style={{ fontSize: 12 }}>{errors.novoValor}</div>
                )}
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Motivo <span className="text-danger">*</span></Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  name="motivo"
                  value={values.motivo}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  isInvalid={touched.motivo && !!errors.motivo}
                  placeholder="Informe o motivo da alteração"
                />
                <Form.Control.Feedback type="invalid">{errors.motivo}</Form.Control.Feedback>
              </Form.Group>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={onHide} disabled={isSubmitting}>
                Cancelar
              </Button>
              <Button type="submit" variant="primary" disabled={isSubmitting}>
                {isSubmitting ? <Spinner animation="border" size="sm" /> : 'Confirmar'}
              </Button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  );
};

export default ModalAlterarOpcaoPagamento;
